import apiClient from 'userportal/lib/ApiClient';
import { actions as authActions, AUTH_LOGIN, AUTH_LOGOUT, AUTH_ALREADY_LOGGED_OUT } from 'userportal/ducks/auth';
import config from 'userportal/config';
import { HTTP_REQUEST_ABORTED } from 'shared/constants';

export default function ({ dispatch, getState }) {
  return next => (action) => {
    /* thunk actions, most propably not needed
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }
    */
    const { callApi, type, types = [], onSuccess = [], onFailure = [], onAbort = [], silent401Error, ...rest } = action;
    if (!callApi) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE, FINALLY, ABORTED] = types;
    if (REQUEST) {
      next({ ...rest, type: REQUEST });
    }

    const { auth = {} } = getState();

    return callApi(apiClient.redux)
      .then(
        (result) => {
          if (SUCCESS) {
            dispatch({ ...rest, result, type: SUCCESS });
          }

          onSuccess.forEach((succAction) => {
            const actionBody = (typeof succAction === 'function') ? succAction(result) : succAction;

            if (actionBody && actionBody.type) {
              dispatch(actionBody);
            }
          });
        },
        (error) => {
          if (error.status === 401 && type !== AUTH_LOGIN) {
            if (config.developmentMode) {
              console.error('HTTP 401 response from API', 'action', action, 'error', error, 'auth', auth);
            }

            if (silent401Error) {
              return;
            }

            if (action.type === AUTH_LOGOUT) {
              dispatch({ type: AUTH_ALREADY_LOGGED_OUT });
            } else {
              dispatch(authActions.forceLogout());
            }
          } else if (error.status === HTTP_REQUEST_ABORTED) {
            if (ABORTED) {
              dispatch({ ...rest, type: ABORTED });
            }

            onAbort.forEach((abortAction) => {
              const actionBody = (typeof abortAction === 'function') ? abortAction() : abortAction;
              if (actionBody && actionBody.type) {
                dispatch(actionBody);
              }
            });
          } else {
            if (FAILURE) {
              dispatch({ ...rest, error: error.error, type: FAILURE });
            }

            onFailure.forEach((failureAction) => {
              const actionBody = (typeof failureAction === 'function') ? failureAction(error) : failureAction;
              if (actionBody && actionBody.type) {
                dispatch(actionBody);
              }
            });
          }
        }
      ).then(() => {
        if (FINALLY) {
          dispatch({ ...rest, type: FINALLY });
        }
      })
      .catch((error) => {
        if (config.developmentMode) {
          console.error('API MIDDLEWARE ERROR', error, 'action', action);
        }
        dispatch({ ...rest, error, type: FAILURE });
      });
  };
}
